import {
  Component,
  OnInit,
  OnDestroy,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormControl, Validators } from '@angular/forms';
import * as moment from 'moment';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-score-analysis',
  templateUrl: './score-analysis.component.html',
  styleUrls: ['./score-analysis.component.scss'],
})
export class ScoreAnalysisComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  role = localStorage['roleId'];
  testId = null;
  testType = '';
  testCode = '';
  isDigital: boolean = false;
  scores: any = new MatTableDataSource([]);
  columnsToDisplay = [
    'student',
    'date',
    'reading',
    'writing',
    'readingAndWriting',
    'math',
    'total',
  ];
  digitalColumns: string[] = ['student', 'date'];
  newDigitalColumns: string[] = [];
  digitalGridStyle: any = {};
  fromDate = new FormControl(null, [Validators.required]);
  toDate = new FormControl(null, [Validators.required]);
  searchClicked = false;
  searchError = false;
  paramSubscription: Subscription | undefined;
  showLoader: boolean = false;
  @ViewChild(MatSort, { static: false }) scoreSort: MatSort | undefined;
  @ViewChild(MatSort, { static: false }) digitalSort: MatSort | undefined;
  @ViewChild(MatPaginator, { static: false }) paginator:
    | MatPaginator
    | undefined;
  private readonly notifier: NotifierService;
  constructor(
    private route: ActivatedRoute,
    notifierService: NotifierService,
    private httpClient: HttpClient
  ) {
    this.notifier = notifierService;
  }

  ngOnInit() {
    this.showLoader = true;
    this.paramSubscription = this.route.params.subscribe((params: Params) => {
      this.testId = params['testId'];
      this.httpClient
        .get(`/api/test_details?testId=${this.testId}`, {
          headers: {
            Authorization: 'Bearer ' + localStorage['accessToken'],
          },
        })
        .subscribe(
          (response: any) => {
            console.log(response);
            this.showLoader = false;
            this.testType = response[0]['testTypeName'];
            this.isDigital = this.testType.includes('Digital');
            this.testCode = response[0]['testCode'];
          },
          (error) => {
            console.log(error);
            this.showLoader = false;
            this.notifier.notify('error', 'Unable to fetch test details');
          }
        );
    });
  }

  ngAfterViewInit(): void {
    this.scores.paginator = this.paginator;
  }

  getDate(date: any) {
    return moment(date).format('MM-DD-YYYY');
  }

  searchQuestions() {
    if (!this.searchClicked) {
      this.searchClicked = true;
      this.searchError = false;
      let errorOccurred = false;
      if (this.fromDate['invalid'] || this.toDate['invalid']) {
        errorOccurred = true;
      }
      this.searchError = errorOccurred;
      if (!errorOccurred) {
        const fromDate = moment(this.fromDate['value']).format('MM-DD-YYYY');
        const toDate = moment(this.toDate['value']).format('MM-DD-YYYY');
        this.httpClient
          .get(
            `/api/analyze_test_scores?testId=${this.testId}&fromDate=${fromDate}&toDate=${toDate}`,
            {
              headers: {
                Authorization: 'Bearer ' + localStorage['accessToken'],
              },
            }
          )
          .subscribe(
            (response: any) => {
              console.log(response);
              this.searchClicked = false;
              console.log(JSON.parse(response['data']));
              const data = JSON.parse(response['data']);
              const scores = data['scores'];
              const scoringSections = data['scoringSections'];
              const uniqueStudentTests = [];
              for (let i = 0; i < scores['length']; i++) {
                const studentTestIndex = uniqueStudentTests.findIndex(
                  (studentTest) =>
                    studentTest['studentTestId'] === scores[i]['studentTestId']
                );
                const score = { ...scores[i] };
                if (studentTestIndex < 0) {
                  const sections: any = {};
                  sections[score['scoringSectionId']] = {
                    scoringSectionId: score['scoringSectionId'],
                    score: score['score'],
                    scoringSectionName:
                      scoringSections[score['scoringSectionId']],
                  };
                  uniqueStudentTests.push({
                    studentTestId: score['studentTestId'],
                    studentName: score['studentName'],
                    studentId: score['studentId'],
                    testDate: score['testDate'],
                    sections,
                  });
                } else {
                  uniqueStudentTests[studentTestIndex]['sections'][
                    score['scoringSectionId']
                  ] = {
                    scoringSectionId: score['scoringSectionId'],
                    score: score['score'],
                    scoringSectionName:
                      scoringSections[score['scoringSectionId']],
                  };
                }
              }
              console.log(uniqueStudentTests);
              const originialData = [];
              if (!this.isDigital) {
                for (let i = 0; i < uniqueStudentTests['length']; i++) {
                  const studentTest: any = { ...uniqueStudentTests[i] };
                  studentTest['readingAndWriting'] =
                    studentTest['sections'][1]['score'] +
                    studentTest['sections'][2]['score'];
                  studentTest['math'] = studentTest['sections'][3]['score'];
                  studentTest['total'] =
                    studentTest['sections'][1]['score'] +
                    studentTest['sections'][2]['score'] +
                    studentTest['sections'][3]['score'];
                  originialData.push(studentTest);
                }
                originialData.sort((first, second) =>
                  first['total'] < second['total'] ? 1 : -1
                );
                console.log(originialData);
                this.scores = new MatTableDataSource(originialData);
                this.scores.sortingDataAccessor = (
                  item: any,
                  property: any
                ) => {
                  console.log(item, property);
                  switch (property) {
                    case 'reading':
                      return item['sections'][1]['score'];
                    case 'writing':
                      return item['sections'][2]['score'];
                    default:
                      return item[property];
                  }
                };
                this.scores.sort = this.scoreSort;
                this.scores.paginator = this.paginator;
              } else {
                this.newDigitalColumns = [];
                this.digitalColumns = ['student', 'date'];
                for (let section in scoringSections) {
                  this.digitalColumns.push(scoringSections[section]);
                  this.newDigitalColumns.push(scoringSections[section]);
                }
                this.digitalColumns.push('total');
                uniqueStudentTests.forEach((test: any) => {
                  console.log(test);
                  let total = 0;
                  for (let section in test.sections) {
                    test[test.sections[section].scoringSectionName] =
                      test.sections[section].score;
                    total += test.sections[section].score;
                  }
                  test['total'] = total;
                });
                uniqueStudentTests.sort((first: any, second: any) =>
                  first['total'] < second['total'] ? 1 : -1
                );
                this.digitalGridStyle = {
                  'grid-template-columns': `repeat(${this.digitalColumns.length}, 1fr)`,
                };
                this.scores = new MatTableDataSource(uniqueStudentTests);
                this.scores.sort = this.digitalSort;
                this.scores.paginator = this.paginator;
              }
            },
            (error) => {
              console.log(error);
              this.searchClicked = false;
              this.notifier.notify('error', 'No Question Data Found');
            }
          );
      } else {
        this.searchClicked = false;
      }
    }
  }

  ngOnDestroy() {
    if (this.paramSubscription) {
      this.paramSubscription.unsubscribe();
    }
  }
}
